import React from 'react'
import ReactDOM from 'react-dom/client'
import './plugins/sqlitePlugin'
import './plugins/apiPlugin'
import App from './App'
import { Capacitor } from '@capacitor/core'
import { CapacitorUpdater } from '@capgo/capacitor-updater'

window.addEventListener('DOMContentLoaded', async () => {
	ReactDOM.createRoot(document.getElementById('reactroot')!).render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	)

	// This tells Capacitor Updator that the current update bundle has loaded
	// succesfully. Failing to call this method will cause your application to be
	// rolled back to the previously successful version (or built-in bundle).
	if(Capacitor.isNativePlatform()) {
		CapacitorUpdater.notifyAppReady()
	}
})
